import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./Pages/Home";
import Products from "./Pages/Products";
import About from "./Pages/About";
import CeramicComponents from "./Pages/CeramicComponents";
import Contact from "./Pages/Contact";
import Cart from "./Pages/Cart";
import "./App.css";

function App() {
  const location = useLocation();

  useEffect(() => {
    // First immediate reset
    window.scrollTo(0, 0);

    // Second reset after layout render
    const timeout = setTimeout(() => {
      const scrollElement =
        document.scrollingElement || document.documentElement;

      scrollElement.scrollTop = 0;
    }, 50);

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/CeramicComponents" element={<CeramicComponents />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;